/**
 * @desc 单选框
 * @author Kody
 */
import React from 'react';

import { classSet } from '@umu/umu-dom';

interface IProps {
    className?: string;
    isChecked: boolean;
    children: JSX.Element | string;
    onChange: (isChecked: boolean) => void;
    disabled?: boolean;
}

import './radio.scss';
export const Radio = (props: IProps) => {
    const { className = '', disabled, children, isChecked, onChange } = props;
    const cls = classSet({
        'umu-radio': true,
        [className]: true,
        'checked': isChecked,
        'disabled': !!disabled,
    });

    const render = () => {
        const checkHandle = () => {
            onChange(!isChecked);
        };
        return (
            <div className={cls} onClick={checkHandle}>
                <span className="input-block" />
                <div className="label">{children}</div>
            </div>
        );
    };

    return render();
};
